export default __webpack_public_path__ + "static/37-fit-ffcc5609a4e8ef7497c4648e6e03502f.png";